import * as React from 'react';
import styled, { css } from 'styled-components';
import cl from 'classnames';

import { LAYER } from '@doltech/utils/lib/constants';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const HEADER_HEIGHT = 64;
const SIDEBAR_WIDTH = 240;

const bottomSheetStyles = css`
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: ${LAYER.LAYER3};

  width: 100%;
`;

const popoverStyles = css`
  position: fixed;
  top: ${HEADER_HEIGHT + 4}px;
  right: 32px;
  z-index: ${LAYER.LAYER3};

  width: auto;
`;

const sidebarStyles = css`
  position: fixed;
  top: ${HEADER_HEIGHT + 32}px;
  left: 32px;
  z-index: ${LAYER.LAYER1};

  width: ${SIDEBAR_WIDTH}px;
`;

const SidebarOverlay = styled.div`
  position: fixed;
  background-color: rgba(36, 41, 56, 0.45);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: ${LAYER.LAYER2};
  visibility: hidden;
  user-select: none;
  transition: visibility 0.1s linear;

  &.visible {
    visibility: visible;
  }

  ${fromScreen(600)} {
    display: none;
  }
`;

const Sidebar = styled.div`
  ${bottomSheetStyles}

  ${fromScreen(600)} {
    ${popoverStyles}
  }

  ${fromScreen(1280)} {
    ${sidebarStyles}
  }
`;

interface StudentDictationSidebarLayoutProps {
  visible?: boolean;
  children?: React.ReactNode;
}

export const StudentDictationSidebarLayout = (props: StudentDictationSidebarLayoutProps) => {
  const { visible, children } = props;

  return (
    <>
      <SidebarOverlay className={cl('sidebar-overlay', { visible })} />
      <Sidebar>{children}</Sidebar>
    </>
  );
};
